import React, { useEffect, useState } from "react";
import {
  CLOSE_BLACK_IC,
  CLOSE_IC,
  CLOSE_IC_18,
  dagabengalurulogoPNG,
  DELETE_IC,
  LIKED_IC,
  UNLIKE_IC,
} from "../../../assets";
import {
  useAddToCustomerBagMutation,
  useAddToWishlistMutation,
  useRemoveFromCustomerBagMutation,
  useRemoveFromWishlistMutation,
} from "../../../redux/slices/homeSlice";
import { toast } from "react-toastify";
import { useDispatch, useSelector } from "react-redux";
import useGetUser from "../../../hooks/useGetUser";
import {
  addToMyBag,
  removeFromMyBag,
  setMyBag,
} from "../../../redux/slices/myBagSlice";
import { useNavigate } from "react-router-dom";
import MODEL from "../../Master/MODEL";
import BTN from "../../Master/BTN";

const ShoppingBagProductCardNew = ({ data, setLensStep }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const user = useGetUser();
  const myBagItems = useSelector((state) => state.myBagData.items);

  const [lensAddModelToggle, setLensAddModelToggle] = useState(false);
  const [selectedShowPrescription, setSelectedShowPrescription] =
    useState(null);

  const [loggedIn, setLoggedIn] = useState(false);
  useEffect(() => {
    if (user?.customer) {
      setLoggedIn(true);
    }
  }, [user]);

  // ===================== REMOVE FROM BAG HANDLE ==================

  const [removeFromCustomerBag] = useRemoveFromCustomerBagMutation();

  const removeToMyBagHandel = (isAllDelete) => {
    if (loggedIn) {
      removeFromCustomerBag({
        body: {
          product_id: data?._id,
          decrement: data?.quantity > 1 && !isAllDelete ? true : false,
        },
        user: localStorage.getItem("user"),
      }).then((res) => {
        if (res?.data) {
          toast.success(`${data?.name} removed from bag successfully.`);
        } else {
          toast.error(`${res?.error?.data?.message}`);
        }
      });
    } else {
      dispatch(removeFromMyBag({ id: data?._id, isAllDelete }));
    }
  };

  // ====================== ADD TO BAG HANDLE ================================

  const [addToCustomerBag] = useAddToCustomerBagMutation();

  const addToMyBagHandel = () => {
    if (loggedIn) {
      addToCustomerBag({
        body: {
          products: [
            {
              product_id: data?._id,
              quantity: 1,
              variant: [],
              lens: [],
            },
          ],
        },
        user: localStorage.getItem("user"),
      }).then((res) => {
        if (res?.data) {
          toast.success(`${data?.name} added to bag successfully.`);
        } else {
          toast.error(`${res?.error?.data?.message}`);
        }
      });
    } else {
      dispatch(addToMyBag({ ...data, quantity: 1 }));
      toast.success(`${data?.name} added to bag successfully.`);
    }
  };

  // =================== ADD CART HANDLE =================

  const addCartHandle = (isAddLens) => {
    if (isAddLens) {
      navigate(user?.customer ? "/lens" : "/login", {
        state: { id: data?._id },
      });
      setLensStep(1);
    } else {
      addToMyBagHandel();
    }
    setLensAddModelToggle(false);
  };

  // ====================== REMOVE LENS HANDLE ================================

  const removeLensFromMyBag = (productId, lensId, prescriptionId) => {
    if (loggedIn) {
      removeFromCustomerBag({
        body: {
          product_id: productId,
          lens_id: lensId,
          prescription_id: prescriptionId,
          decrement: true,
        },
        user: localStorage.getItem("user"),
      }).then((res) => {
        if (res?.data) {
          toast.success(`Lens Removed`);
        } else {
          toast.error(`${res?.error?.data?.message}`);
        }
      });
    }
  };

  const totalWithLens = data?.lensDetails?.reduce(
    (acc, lens) => acc + (lens?.price || 0),
    0
  );

  return (
    <div className="w-full flex flex-col bg-bg_1 mt-4 emd:mt-0 pt-3">
      <div className="flex flex-row items-center justify-between">
        {data?.stock <= 0 ? (
          <div className="new-arrival-label-mybag-card  bg-text_dark_3 text-white px-4 py-1 text-xs max-w-fit mb-3 -ml-[6px] cursor-default">
            MAKE TO ORDER
          </div>
        ) : <div></div>}
        <img
          src={DELETE_IC}
          alt=""
          className="w-6 cursor-pointer aspect-square object-contain mb-4 mr-4"
          onClick={() => removeToMyBagHandel(true)}
        />
      </div>
      <div className="flex w-full mb-3 px-4 pb-4">
        <div
          className="lg:min-w-[140px] lg:max-w-[140px] lg:min-h-[120px] lg:max-h-[120px]
      emd:min-w-[140px] emd:max-w-[140px] emd:min-h-[120px] emd:max-h-[120px]
      small:min-w-[120px] small:max-w-[120px] small:min-h-[100px] small:max-h-[100px]
       object-contain flex items-center justify-center overflow-hidden bg-white"
        >
          <img
            onClick={() => navigate(`/products/${data?._id}`)}
            src={
              data?.image?.length > 0
                ? data?.image[0].replace(
                    "upload/",
                    "upload/if_w_gt_150/w_150/if_end/"
                  )
                : dagabengalurulogoPNG
            }
            className="w-[120px] h-full aspect-square object-contain p-2 cursor-pointer"
            alt=""
          />
        </div>
        <div className="lg:w-[calc(100%-140px)] emd:w-[calc(100%-140px)] small:w-[calc(100%-120px)] pl-4 flex flex-col">
          <div className="w-full flex lg:flex-row emd:flex-row mxs:flex-row lm:flex-row small:flex-col-reverse small:items-end emd:items-start lg:items-start justify-between">
            <span
              onClick={() => navigate(`/products/${data?._id}`)}
              className=" lg:text-base emd:text-base small:text-base cursor-pointer"
            >
              {data?.name}
            </span>
            {/* <img
              src={DELETE_IC}
              alt=""
              className="w-6 cursor-pointer"
              onClick={() => removeToMyBagHandel(true)}
            /> */}
          </div>
          <span
            onClick={() => navigate(`/products/${data?._id}`)}
            className="text-base  w-fit cursor-pointer"
          >
            {/* <span className="currency_symbol">₹</span> */}
            {data?.netWeight}&nbsp;g
          </span>
          <div className="w-fit flex items-center justify-between mt-2">
            <button
              onClick={() => removeToMyBagHandel(false)}
              className={` 
             w-5 h-5 border  text-center text-sm`}
            >
              -
            </button>
            <div className="mx-2 text-sm">{data?.quantity}</div>
            <button
              // onClick={() => setLensAddModelToggle(false)}
              onClick={() => addCartHandle(false)}
              className="w-5 h-5 border border-black text-center text-sm"
            >
              +
            </button>
          </div>
          {/* {!data?.lensDetails ? (
            <button
              onClick={() => {
                navigate(user?.customer ? "/lens" : "/login", {
                  state: { id: data?._id, isOnlyLens: true },
                });
                setLensStep(1);
              }}
              className="w-fit border border-secondary text-secondary py-1 px-2 font-bold text-nowrap text-xs mt-2"
            >
              Add Lens
            </button>
          ) : data?.quantity > data?.lensDetails?.length &&
            data?.quantity !== data?.lensDetails?.length ? (
            <button
              onClick={() => {
                navigate(user?.customer ? "/lens" : "/login", {
                  state: { id: data?._id, isOnlyLens: true },
                });
                setLensStep(1);
              }}
              className="w-fit border border-secondary text-secondary py-1 px-2 font-bold text-nowrap text-xs mt-2"
            >
              Add Lens
            </button>
          ) : null} */}
        </div>
      </div>
      {data?.lensDetails?.length > 0 && (
        <div className="w-full flex flex-col">
          <div className=" w-full flex flex-col">
            <div className="text-base  uppercase">
              Lens Details ( {data?.lensDetails?.length} LENS )
            </div>
            {data?.lensDetails?.map((item, index) => {
              return (
                <div
                  key={index}
                  className="w-full flex justify-between items-center mt-2 pb-2"
                >
                  <div
                    className="flex items-center"
                    onClick={() =>
                      setSelectedShowPrescription(item?.prescriptionDetail)
                    }
                  >
                    <span>{index + 1}.</span>
                    <span className="text-base ms-2 cursor-pointer">
                      {item.name + " Lens"} &nbsp;
                      <span className="text-nowrap">(₹ {item.price})</span>
                    </span>
                  </div>
                  <img
                    src={CLOSE_IC}
                    alt=""
                    className="w-6 ms-5 cursor-pointer"
                    onClick={() =>
                      removeLensFromMyBag(
                        data?._id,
                        item?._id,
                        item?.prescriptionDetail?._id
                      )
                    }
                  />
                </div>
              );
            })}
          </div>
        </div>
      )}
      <div className="w-full flex justify-between mt-2 p-4 border-t border-dashed border-light_secondary">
        <span>Total Weight</span>
        <span className="text-base lato-semibold">
          {/* <span className="currency_symbol"></span> */}
          {/* {data?.lensDetails?.length > 0
            ? data?.prices?.price * data?.quantity + (totalWithLens || 0)
            : data?.prices?.price * data?.quantity} */}
          {Number(data?.quantity) > 0 && (
            <>{Number(data?.netWeight * data?.quantity).toFixed(2)}&nbsp;g</>
          )}
        </span>
      </div>

      {/* =================== ADD LENS OR NOT MODEL =============== */}
      <MODEL
        setShowModel={setLensAddModelToggle}
        showModel={lensAddModelToggle}
        isDialogue={true}
      >
        <div className="w-full flex flex-col items-center">
          <div className="w-full flex justify-between bg-bg_1 px-5 py-5">
            <span className=" text-xl ">Select Your Lens</span>
            <img
              src={CLOSE_BLACK_IC}
              alt=""
              className="cursor-pointer"
              onClick={() => setLensAddModelToggle(false)}
            />
          </div>
          <div className="flex flex-col w-full justify-center items-center my-5 px-5">
            <BTN
              onP={() => addCartHandle(true)}
              title="Add Lens"
              className={"w-full  text-lg py-1 px-3"}
            />
            <div className="w-full flex items-center justify-between py-5">
              <div className="border-b border-dashed border-light_secondary w-[40%]"></div>
              <span>OR</span>
              <div className="border-b border-dashed border-light_secondary w-[40%]"></div>
            </div>
            <span
              className="text-primary cursor-pointer text-center"
              onClick={() => addCartHandle(false)}
            >
              Buy Only Frame Without Lens
            </span>
          </div>
        </div>
      </MODEL>

      {/* =================== PRESCRIPTION DETAILS MODEL =============== */}
      <MODEL
        setShowModel={() => setSelectedShowPrescription(null)}
        showModel={selectedShowPrescription !== null}
        isDialogue={true}
      >
        <div className="w-full flex flex-col items-center">
          <div className="w-full flex justify-between bg-bg_1 px-5 py-5">
            <span className=" text-xl ">Prescription details</span>
            <img
              src={CLOSE_BLACK_IC}
              alt=""
              className="cursor-pointer"
              onClick={() => setSelectedShowPrescription(null)}
            />
          </div>
          <div className="w-full my-5 px-5">
            <div className="xl:flex-row emd:flex-row small:flex-col fix_lg:flex-col flex items-center justify-between">
              <div className="xl:w-[49%] emd:w-[49%] small:w-full fix_lg:w-full h-40 flex flex-col justify-evenly items-center xl:border-r emd:border-r small:border-b fix_lg:border-b xl:border-b-0 emd:border-b-0 small:border-r-0 fix_lg:border-r-0 border-light_secondary  xl:pr-3 fix_lg:pr-0 emd:pr-3 small:pr-0 xl:pb-0 emd:pb-0 small:pb-2 fix_lg:pb-2">
                <div className="my-2 text-center font-bold underline underline-offset-4">
                  Left Eye
                </div>
                <div className="w-full flex items-center justify-between mt-3">
                  <span className="text-sm font-bold">Sphere :</span>
                  <span className="text-sm">
                    {selectedShowPrescription?.leftEye?.sphere}
                  </span>
                </div>
                <div className="w-full flex items-center justify-between">
                  <span className="text-sm font-bold">Cylinder :</span>
                  <span className="text-sm">
                    {selectedShowPrescription?.leftEye?.cylinder}
                  </span>
                </div>
                <div className="w-full flex items-center justify-between">
                  <span className="text-sm font-bold">Axis :</span>
                  <span className="text-sm">
                    {selectedShowPrescription?.leftEye?.axis}
                  </span>
                </div>
                <div className="w-full flex items-center justify-between">
                  <span className="text-sm font-bold">PD :</span>
                  <div className="flex items-center">
                    <span className="text-sm">
                      {selectedShowPrescription?.leftEye?.pd}
                    </span>
                    {/* <span className="text-sm ms-2">
                          {selectedShowPrescription?.leftEye?.left_pd}
                        </span> */}
                  </div>
                </div>
                {selectedShowPrescription?.leftEye?.add && (
                  <div className="w-full flex items-center justify-between">
                    <span className="text-sm font-bold">ADD :</span>
                    <div className="flex items-center">
                      <span className="text-sm">
                        {selectedShowPrescription?.leftEye?.add}
                      </span>
                    </div>
                  </div>
                )}
              </div>
              <div className="xl:w-[49%] emd:w-[49%] small:w-full fix_lg:w-full h-40 lg:pl-3 fix_lg:pl-0 emd:pl-3 small:pl-0 flex flex-col justify-evenly items-center">
                <div className="my-2 text-center font-bold underline underline-offset-4">
                  Right Eye
                </div>
                <div className="w-full flex items-center justify-between mt-3">
                  <span className="text-sm font-bold">Sphere :</span>
                  <span className="text-sm">
                    {selectedShowPrescription?.rightEye?.sphere}
                  </span>
                </div>
                <div className="w-full flex items-center justify-between">
                  <span className="text-sm font-bold">Cylinder :</span>
                  <span className="text-sm">
                    {selectedShowPrescription?.rightEye?.cylinder}
                  </span>
                </div>
                <div className="w-full flex items-center justify-between">
                  <span className="text-sm font-bold">Axis :</span>
                  <span className="text-sm">
                    {selectedShowPrescription?.rightEye?.axis}
                  </span>
                </div>
                <div className="w-full flex items-center justify-between">
                  <span className="text-sm font-bold">PD :</span>
                  <div className="flex items-center">
                    <span className="text-sm">
                      {selectedShowPrescription?.rightEye?.pd}
                    </span>
                    {/* <span className="text-sm ms-2">
                          {item?.leftEye?.right_pd}
                        </span> */}
                  </div>
                </div>
                {selectedShowPrescription?.rightEye?.add && (
                  <div className="w-full flex items-center justify-between">
                    <span className="text-sm font-bold">ADD :</span>
                    <div className="flex items-center">
                      <span className="text-sm">
                        {selectedShowPrescription?.rightEye?.add}
                      </span>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </MODEL>
    </div>
  );
};

export default ShoppingBagProductCardNew;
